module.exports = "https://cdn2-fs.clearscore.com/flux/images/f268e4580650fc0d4dad099cc425ff3a.jpg";